import { useState, useCallback } from 'react';

/**
 * Custom hook for showing confirmation dialogs
 * Returns a function that can be called to show a confirm dialog
 * and returns a Promise that resolves to true/false
 */
export function useConfirm() {
    const [config, setConfig] = useState(null);
    const [resolver, setResolver] = useState(null);

    const confirm = useCallback((options = {}) => {
        return new Promise((resolve) => {
            setConfig({
                title: options.title || 'Confirm Action',
                message: options.message || 'Are you sure you want to proceed?',
                confirmText: options.confirmText || 'Confirm',
                cancelText: options.cancelText || 'Cancel',
                danger: options.danger !== undefined ? options.danger : false,
                icon: options.icon || 'warning'
            });
            setResolver(() => resolve);
        });
    }, []);

    const handleConfirm = useCallback(() => {
        if (resolver) {
            resolver(true);
            setConfig(null);
            setResolver(null);
        }
    }, [resolver]);

    const handleCancel = useCallback(() => {
        if (resolver) {
            resolver(false);
            setConfig(null);
            setResolver(null);
        }
    }, [resolver]);

    return {
        confirm,
        ConfirmDialog: config ? {
            isOpen: true,
            onConfirm: handleConfirm,
            onCancel: handleCancel,
            ...config
        } : null
    };
}
